import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { appRoutes } from 'utils';
import LazyLoadPage from 'pages/LazyLoadPage/LazyLoadPage';
import RegisterPage from 'pages/RegisterPage';
import LoginPage from 'pages/LoginPage';
import DepartmentsPage from 'pages/WorkspacePage/Departments';
import ManageQaPage from 'pages/WorkspacePage/ManageQA';
import MembersPage from 'pages/WorkspacePage/Members';
import Teams from 'pages/WorkspacePage/Teams';

import { useUserStore } from 'store';
import { UserRole } from 'types/api.d';

const ErrorPage = lazy(() => import('pages/ErrorPage'));
const HomePage = lazy(() => import('pages/HomePage'));
const ChatPage = lazy(() => import('pages/ChatPage'));
const ForgotPasswordPage = lazy(() => import('pages/ForgotPasswordPage'));
const DocumentsPage = lazy(() => import('pages/DocumentsPage'));
const DocumentPage = lazy(() => import('pages/DocumentPage'));
const LazyWorkspace = lazy(() => import('pages/WorkspacePage'));
const DashboardPage = lazy(() => import('pages/DashboardPage'));

const Routing = () => {
  const { role } = useUserStore();
  return (
    <Routes>
      <Route path={`*`} element={<LazyLoadPage children={<ErrorPage />} />} />
      <Route
        path={appRoutes.home}
        element={<LazyLoadPage children={<HomePage />} />}
      >
        <Route index element={<LazyLoadPage children={<ChatPage />} />} />
        {role === UserRole.SA && (
          <Route
            path={appRoutes.dashboard}
            element={<LazyLoadPage children={<DashboardPage />} />}
          />
        )}
        <Route
          path={appRoutes.documents}
          element={<LazyLoadPage children={<DocumentsPage />} />}
        />
        <Route
          path="documents/:id"
          element={<LazyLoadPage children={<DocumentPage />} />}
        />
        <Route
          path={appRoutes.workspace}
          element={<LazyLoadPage children={<LazyWorkspace />} />}
        >
          <Route
            index
            path={appRoutes.workspace}
            element={<LazyLoadPage children={<ManageQaPage />} />}
          />
          <Route
            path={appRoutes.workspaceDepartments}
            element={<LazyLoadPage children={<DepartmentsPage />} />}
          />
          <Route
            path={appRoutes.workspaceMembers}
            element={<LazyLoadPage children={<MembersPage />} />}
          />
          <Route
            path={appRoutes.workspaceTeams}
            element={<LazyLoadPage children={<Teams />} />}
          />
        </Route>
      </Route>

      <Route
        path={appRoutes.register}
        element={<LazyLoadPage children={<RegisterPage />} />}
      />
      <Route
        path={appRoutes.login}
        element={<LazyLoadPage children={<LoginPage />} />}
      />
      <Route
        path={appRoutes.forgotPassword}
        element={<LazyLoadPage children={<ForgotPasswordPage />} />}
      />
    </Routes>
  );
};

export default Routing;
